<template>
  <div
    id="app"
    ref="screen-wrap"
    :style="`zoom:${scaleRadio};  color: #2c3e50;`"
  >
    <router-view />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "App",
  data() {
    return {
      scaleRadio: 1,
    };
  },
  created() {
    this.getZoom();
  },
  mounted() {
    window.addEventListener("resize", (res) => {
      this.getZoom();
    });
    document.addEventListener(
      "mousewheel",
      function (e) {
        e = e || window.event;
        if ((e.wheelDelta && event.ctrlKey) || e.detail) {
          event.preventDefault();
        }
      },
      { passive: false }
    );
  },
  computed: {
    // 通过global获取user的信息
    ...mapState("global", {
      user: (state) => state.user,
    }),
    isInQiankun() {
      return window.__POWERED_BY_QIANKUN__;
    },
  },
  methods: {
    // setGlobalState 是在 /common/src/store/global-register.js中定义的
    ...mapActions("global", ["setGlobalState"]),
    gotoSubReact() {
      history.pushState(null, "sub-react", "/sub-react");
    },
    changeUsername() {
      // 也可通过 store.commit('global/setGlobalState', { user: '李四' }) 进行操作
      this.setGlobalState({
        user: { name: "李四" + Math.round(Math.random() * 100) },
      });
    },
    openSubVue() {
      if (!this.isInQiankun) {
        alert("当前已经是单独运行的子应用");
        return;
      }

      // window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__ 是qiankun注入的子应用对应的地址，谨慎使用，生产环境建议将跳转地址维护在环境变量中
      window.open(window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__);
    },
    getZoom() {
      this.scaleRadio = 1;
      // setTimeout(() => {
      //   if (this.$route.path == "/worship" || this.$route.path == "/login") {
      //     this.scaleRadio = 1;
      //   } else {
      //     let windowWidth =
      //       document.documentElement.offsetWidth || document.body.offsetWidth;
      //     this.scaleRadio = windowWidth / 1920;
      //   }
      // });
    },
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "pf";
  src: url("https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/font/pf.ttf")
    format("truetype");
  font-display: swap;
}
* {
  padding: 0;
  margin: 0;
  user-select: none;
}
img {
  user-select: none;
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
  -webkit-user-drag: none;
}
a {
  text-decoration: none;
}
#app {
  font-family: "pf";
  //font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 16px;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.btns {
  margin: 100px;
}
.btns button {
  margin: 0 10px;
}
</style>
